
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiAlertCircleOutline } from "@mdi/js";
import { defineComponent, computed, PropType, toRef } from "@vue/runtime-core";

interface Props {
  errors: Record<string, string>;
}

export default defineComponent({
  components: {
    SvgIcon,
  },
  props: {
    errors: {
      type: Object as PropType<Record<string, string>>,
      required: true,
    },
  },
  setup(props: Props) {
    const errors = toRef(props, "errors");

    const hasErrors = computed(() => {
      return Object.keys(errors.value).length > 0;
    });

    return {
      alertIcon: mdiAlertCircleOutline,
      errors,
      hasErrors,
    };
  },
});
